"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

// Google Ads "การดูหน้าเว็บ" conversion for AW-847034928.
//
// Google's snippet is a plain <script> in <head>, which fires once per full
// document load. This site navigates client-side, so a head snippet would miss
// every page after the first — hence a component that re-fires on each route.
// gtag() itself is defined by the inline bootstrap in the layout <head>, so it
// exists before this ever runs; the typeof guard is for the SSR pass only.
export default function AdsPageViewConversion() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") {
      return;
    }

    window.gtag("event", "conversion", {
      send_to: "AW-847034928/mW9GCK_tw8QaELD08pMD",
      value: 1.0,
      currency: "USD",
    });
  }, [pathname]);

  return null;
}
